var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRotateLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00023 1.33413C6.64184 1.33413 5.37741 1.74711 4.32184 2.44742L3.32184 1.44742C3.08051 1.20542 2.6669 1.37625 2.6669 1.71825V4.28466C2.6669 4.49599 2.83838 4.66747 3.04971 4.66747H5.61612C5.95812 4.66747 6.12895 4.25385 5.88695 4.01252L5.28669 3.41226C6.08135 2.94088 7.00617 2.66747 8.00023 2.66747C10.954 2.66747 13.3336 5.04702 13.3336 8.0008C13.3336 10.9546 10.954 13.3341 8.00023 13.3341C5.04645 13.3341 2.6669 10.9546 2.6669 8.0008C2.66815 7.91246 2.65182 7.82475 2.61888 7.74277C2.58594 7.66079 2.53703 7.58618 2.475 7.52327C2.41297 7.46035 2.33906 7.4104 2.25755 7.3763C2.17605 7.3422 2.08858 7.32464 2.00023 7.32464C1.91188 7.32464 1.82441 7.3422 1.74291 7.3763C1.6614 7.4104 1.58749 7.46035 1.52546 7.52327C1.46343 7.58618 1.41452 7.66079 1.38158 7.74277C1.34863 7.82475 1.33231 7.91246 1.33356 8.0008C1.33356 11.675 4.32601 14.6675 8.00023 14.6675C11.6745 14.6675 14.6669 11.675 14.6669 8.0008C14.6669 4.32658 11.6745 1.33413 8.00023 1.33413Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateLeft);
export default __webpack_public_path__ + "static/media/RotateLeft.9f8016e9edf9ed3da6dfcc3e058b5352.svg";
export { ForwardRef as ReactComponent };